import React from "react"
import { Card } from "react-bootstrap"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardBodyProps extends WithClassName {
  children?: React.ReactNode
}

export const ProjectCardBody = React.memo(
  ({ children, className }: ProjectCardBodyProps) => (
    <Card.Body className={classNames("project-card__body", className)}>
      {children}
    </Card.Body>
  )
)
